import {
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  Link,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Box,
  Flex,
} from "@chakra-ui/react";

import { AiOutlineMore } from "react-icons/ai";

import { IconBackgroundContainer, TextPrimary } from "theme";
import { ChervonRight, iconMapping } from "icons";

import IconComponent from "@components/Icon";
import ThemeSwitcher from "@components/ThemeSwitcher";

import { StrapiSubHeaderOption } from "@customtypes/global";

interface HeaderProps {
  headerOptins: StrapiSubHeaderOption[];
  shouldDisplayMenu: boolean;
  onChangeDisplayMenu(isVisible: boolean): void;
  onSubHeaderMenuClick(key: string): void;
}

const SubHeader = ({
  headerOptins,
  shouldDisplayMenu,
  onChangeDisplayMenu,
  onSubHeaderMenuClick,
}: HeaderProps) => {
  const getHeaderItem = (item: StrapiSubHeaderOption) => {
    return (
      <Flex justifyContent="space-between" alignItems="center" mt="1.5rem">
        <Flex alignItems="center">
          <IconBackgroundContainer bg="backgroundPrimary" h="40px" w="40px">
            {item.icon_key && (
              <IconComponent
                Icon={iconMapping(item.icon_key)}
                width="24px"
                height="24px"
                color="textSecondary"
              />
            )}
          </IconBackgroundContainer>

          <TextPrimary
            fontWeight="600"
            fontSize="16px"
            lineHeight="24px"
            ml="1rem"
          >
            {item.title}
          </TextPrimary>
        </Flex>

        {item.key === "theme" ? (
          <Box>
            <ThemeSwitcher />
          </Box>
        ) : (
          <Box
            color="primary"
            _dark={{
              color: "textPrimary",
            }}
          >
            <IconComponent width="24px" height="24px" Icon={ChervonRight} />
          </Box>
        )}
      </Flex>
    );
  };

  const getSubHeader = () =>
    headerOptins?.map((item) =>
      item?.link ? (
        <Link
          cursor="pointer"
          href={item.link}
          target="_blank"
          rel="nofollow"
          key={item.title}
          onClick={() => onSubHeaderMenuClick(item.key)}
        >
          {getHeaderItem(item)}
        </Link>
      ) : (
        <Box key={item.title}>{getHeaderItem(item)}</Box>
      )
    );

  return (
    <>
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          fontSize="24px"
          icon={<AiOutlineMore height="24px" width="24px" />}
          variant="icon"
          ml={{ base: "4px", lg: "1rem" }}
          mr={{ base: 0, lg: "2.5rem" }}
          bg="backgroundSecondary"
          display={{ base: "none", md: "inline-flex" }}
          borderRadius="0.5rem"
        />
        <MenuList
          borderRadius="1rem"
          border="1px solid"
          borderColor="seperator"
          bg="backgroundSecondary"
          p="0rem 1.5rem 2.5rem"
          display="flex"
          flexDirection="column"
          boxShadow="4px 24px 40px rgba(0, 0, 0, 0.12)"
          width="280px"
          maxW="98%"
          zIndex="4"
        >
          {getSubHeader()}
        </MenuList>
      </Menu>
      <Drawer
        isOpen={shouldDisplayMenu}
        onClose={() => onChangeDisplayMenu(false)}
        placement="bottom"
      >
        <DrawerOverlay bg="modalOverlay" />
        <DrawerContent
          bg="backgroundSecondary"
          borderTopRadius="2rem"
          p="2.5rem 1rem"
        >
          <DrawerBody p="0">{getSubHeader()}</DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default SubHeader;
